import React from "react";

import { ScrollingProvider } from "../../context/ScrollingContext";

import SectionHead from "../../components/ui/SectionHead";
import Container from "../../components/ui/Container";
import CourseCard from "../../components/ui/CourseCard";

// import year1 from "../../../assets/year-2.jpeg";
import year2 from "../../assets//Updated-imagery/year2.PNG";
import year3 from "../../assets/Updated-imagery/year3.PNG";
import year1 from "../../assets/Updated-imagery/year1.PNG";
import Waves from "../../components/ui/Waves";
import { Link } from "react-router-dom";
import { ReactComponent as NavigationIcon } from "../../assets/Updated-imagery/arabianboaticon.svg";
import { ReactComponent as HitYearCardDecore } from "../../assets/Updated-imagery/hitYearsIcon.svg";

const YearsSection = ({ title = false, layout = "default" }) => {
    // const { token } = useContext(AuthContext);
    const cardsData = [
        // {
        //     title: "الصف الثالث الإعدادي",
        //     barColor: "bg-royalPurple-400",
        //     description: "جميع كورسات الصف الثالث الإعدادي",
        //     image: year4,
        //     year: 4,
        // },
        {
            title: "الصف الأول الثانوي",
            barColor: "bg-amrYellow-400",
            description: "جميع كورسات الصف الأول الثانوي",
            image: year1,
            year: 1,
        },
        {
            title: "الصف الثاني الثانوي",
            barColor: "bg-royalPurple-400",
            description: "جميع كورسات الصف الثاني الثانوي",
            image: year2,
            year: 2,
        },
        {
            title: "الصف الثالث الثانوي",
            barColor: "bg-amrYellow-400",
            description: "جميع كورسات الصف الثالث الثانوي",
            image: year3,
            year: 3,
        },
    ];
    return (
        <>
            <div className="relative mb-20 overflow-hidden w-full" id="courses" dir="rtl">
                {layout === "default" ? (
                    <div>
                        <ScrollingProvider>
                            <SectionHead title={title ? title : "السنوات الدراسية"} />
                        </ScrollingProvider>

                        <Container>
                            <div
                                className={`g-teal-400 smooth clr-text-primary drk:bg-teal-800 bg-opacity-50 dark:bg-opacity-50 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10`}
                            >
                                <CourseCard
                                    name="الصف الدراسي الأول"
                                    description="جميع كورسات الصف الأول الثانوي"
                                    isYear={1}
                                    isStaticPicture={year1}
                                />
                                <CourseCard
                                    name="الصف الدراسي الثاني"
                                    description="جميع كورسات الصف الثاني الثانوي"
                                    isYear={2}
                                    isStaticPicture={year2}
                                />
                                <CourseCard
                                    name="الصف الدراسي الثالث"
                                    description="جميع كورسات الصف الثالث الثانوي"
                                    isYear={3}
                                    isStaticPicture={year3}
                                />
                            </div>
                        </Container>
                    </div>
                ) : layout === "glassMorphism" ? (
                    <>
                        <Container>
                            <div className="max-w-7xl mx-auto">
                                <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-16">
                                    {cardsData.map((card, index) => (
                                        <Link to={`/years/${card.year}`}>
                                            <div
                                                key={index}
                                                className="w-full group box-shadow-yearCard md:min-w-[320px] lg:min-w-[380px] xl:min-w-[480px] bg-third-container smooth rounded-lg shadow-sm overflow-hidden"
                                            >
                                                <div
                                                    className={`h-2 w-1/2 mx-auto ${card.barColor}`}
                                                ></div>

                                                <div className="h-auto w-full overflow-hidden">
                                                    <img
                                                        src={card.image}
                                                        alt={card.title}
                                                        className="w-full max-w-[480px] group-hover:scale-105 group-hover:-translate-y-2 group-hover:brightness-105 group-hover:saturate-100 smooth"
                                                    />
                                                </div>

                                                <div className="p-6">
                                                    <div className="bg-white/10 backdrop-blur-md box-shadow-yearCard rounded-lg border border-white/30 p-4 -mt-12 mx-4 relative z-10 ring-1 ring-white/20">
                                                        <div className="flex flex-col items-center justify-center gap-2">
                                                            <h3 className="font-h3 font-semibold text-gray-700 dark:text-gray-100 smooth text-center">
                                                                {card.title}
                                                            </h3>
                                                            <p className="text-sm text-gray-500 dark:text-gray-400 smooth">
                                                                {card.description}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Link>
                                    ))}
                                </div>
                            </div>
                        </Container>
                        {/* <Waves className="fill-yellow-200" /> */}
                        {/* <div className="py-16 bg-yellow-200"></div> */}
                    </>
                ) : layout === "bannerThumbnail" ? (
                    <Container>
                        <div className="w-full max-w-7xl mx-auto">
                            <div className="flex items-center flex-wrap gap-10">
                                {cardsData.map((card, index) => (
                                    <Link to={`/years/${card.year}`} key={index}>
                                        <div className="group relative bg-white dark:bg-gray-800 rounded-xl overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105">
                                            <div className={`h-1 w-full ${card.barColor}`}></div>

                                            <div className="relative overflow-hidden">
                                                <img
                                                    src={card.image}
                                                    alt={card.title}
                                                    className="w-full h-48 object-cover group-hover:scale-110 transition-transform duration-300"
                                                />
                                                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                                            </div>

                                            <div className="absolute bottom-0 left-0 right-0 p-4 bg-gradient-to-t from-black/80 to-transparent text-white transform translate-y-full group-hover:translate-y-0 transition-transform duration-300">
                                                <h3 className="font-bold text-lg mb-1 text-center">
                                                    {card.title}
                                                </h3>
                                                <p className="text-sm text-gray-200 text-center">
                                                    {card.description}
                                                </p>
                                            </div>

                                            <div className="absolute top-4 left-4 w-8 h-8 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                                                <svg
                                                    className="w-4 h-4 text-white"
                                                    fill="none"
                                                    stroke="currentColor"
                                                    viewBox="0 0 24 24"
                                                >
                                                    <path
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                        strokeWidth="2"
                                                        d="M17 8l4 4m0 0l-4 4m4-4H3"
                                                    />
                                                </svg>
                                            </div>
                                        </div>
                                    </Link>
                                ))}
                            </div>
                        </div>
                    </Container>
                ) : layout === "onlyThumbnail" ? (
                    <Container>
                        <div className="w-full mx-auto">
                            <div className="flex items-center justify-center flex-wrap gap-10">
                                {cardsData.map((card, index) => (
                                    <Link to={`/years/${card.year}`} key={index}>
                                        <div className="group relative dark:border border-royalPurple-400  md:min-w-[320px] lg:min-w-[380px] xl:min-w-[480px] bg-white dark:bg-gray-800 rounded-xl overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300">
                                            <div className="relative overflow-hidden">
                                                <img
                                                    src={card.image}
                                                    alt={card.title}
                                                    className="w-full h-[250px] object-cover group-hover:scale-105 transition-transform duration-300"
                                                />

                                                <div className="absolute top-4 right-0 bg-royalPurple-500/60 text-white rounded-tl-lg rounded-bl-lg px-3 py-2 shadow-lg max-w-[200px]">
                                                    <h3 className="font-bold text-sm mb-1 leading-tight">
                                                        {card.title}
                                                    </h3>
                                                    <p className="text-xs text-orange-100 leading-tight">
                                                        {card.description}
                                                    </p>
                                                </div>
                                            </div>

                                            <div className="absolute bottom-4 left-4 w-12 h-12 bg-primary-container rounded-full flex items-center justify-center shadow-lg transition-colors duration-300">
                                                <NavigationIcon className="w-8 h-8 text-white " />
                                            </div>
                                        </div>
                                    </Link>
                                ))}
                            </div>
                        </div>
                    </Container>
                ) : layout === "InteractiveGlassCard" ? (
                    <Container>
                        <div className="w-full mx-auto">
                            <div className="flex items-center justify-center flex-wrap gap-10">
                                {cardsData.map((card, index) => (
                                    <Link
                                        to={`/years/${card.year}`}
                                        className="relative"
                                        key={index}
                                    >
                                        <div>
                                            <HitYearCardDecore className=" w-[100px] h-[100px] absolute z-10 -top-14 -right-10 " />
                                        </div>
                                        <div className="relative w-[350px] sm:w-[400px] md:w-[450px] group h-[250px] rounded-2xl overflow-hidden group transition-all duration-300 hover:shadow-xl ">
                                            <img
                                                src={card.image}
                                                alt={card.title}
                                                className="absolute inset-0 w-full h-full object-cover smooth group-hover:scale-105"
                                            />

                                            <div className="absolute opacity-0 inset-0 bg-white/10 backdrop-blur-md rounded-2xl ring-1 ring-white/20 z-10 group-hover:opacity-100 smooth" />

                                            <div className="absolute bottom-0 w-full p-4 z-20">
                                                <h3 className="text-white text-lg font-bold mb-1">
                                                    {card.title}
                                                </h3>
                                                <p className="text-white/80 text-sm">
                                                    {card.description}
                                                </p>
                                            </div>

                                            <div className="absolute top-4 left-4 w-10 h-10 bg-white/20 backdrop-blur-md rounded-full flex items-center justify-center z-20 group-hover:scale-110 transition">
                                                <NavigationIcon className="w-7 h-7 text-white" />
                                            </div>
                                        </div>
                                    </Link>
                                ))}
                            </div>
                        </div>
                    </Container>
                ) : null}
            </div>
        </>
    );
};
export default YearsSection;
